/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SellerBillingInfoUpdateDTO interface.
 */
export function instanceOfSellerBillingInfoUpdateDTO(value) {
    if (!('companyName' in value) || value['companyName'] === undefined)
        return false;
    return true;
}
export function SellerBillingInfoUpdateDTOFromJSON(json) {
    return SellerBillingInfoUpdateDTOFromJSONTyped(json, false);
}
export function SellerBillingInfoUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'companyName': json['companyName'],
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'district': json['district'] == null ? undefined : json['district'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'taxOffice': json['taxOffice'] == null ? undefined : json['taxOffice'],
        'taxNumber': json['taxNumber'] == null ? undefined : json['taxNumber'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}
export function SellerBillingInfoUpdateDTOToJSON(json) {
    return SellerBillingInfoUpdateDTOToJSONTyped(json, false);
}
export function SellerBillingInfoUpdateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'companyName': value['companyName'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'district': value['district'],
        'city': value['city'],
        'state': value['state'],
        'postalCode': value['postalCode'],
        'country': value['country'],
        'taxOffice': value['taxOffice'],
        'taxNumber': value['taxNumber'],
        'vatNumber': value['vatNumber'],
        'phone': value['phone'],
        'email': value['email'],
    };
}
